import React from "react";
import { Typography } from "@pankod/refine-antd";

const getPercentColor = (value: number) => {
  if (isNaN(value)) return "black";
  if (value > 0) return "green";
  if (value < 0) return "red";
  return "black";
};

const toPercent = (value: number) => {
  if (isNaN(value)) return "";
  const percent = (value * 100).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return percent + "%";
};

const renderNumber = (
  value: string,
  digits: number | undefined,
  displayFunc: Function | undefined,
  props: any
) => {
  const funcDigits = digits !== undefined ? digits : 2;
  let number = parseFloat(value).toLocaleString("en-US", {
    minimumFractionDigits: funcDigits,
    maximumFractionDigits: funcDigits,
  });
  if (isNaN(parseFloat(value))) {
    number = "";
  }
  return renderTypography(!!displayFunc ? displayFunc(number) : number, props);
};

function formatDate(isoString: string): string {
    const date = new Date(isoString);

    const pad = (num: number) => num.toString().padStart(2, '0');

    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1); // Months are zero-based
    const day = pad(date.getDate());

    let hours = date.getHours();
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // The hour '0' should be '12'

    const formattedTime = `${pad(hours)}:${minutes}:${seconds} ${ampm}`;
    const formattedDate = `${year}-${month}-${day} ${formattedTime}`;

    return formattedDate;
}

const renderString = (
  value: string,
  displayFunc: Function | undefined,
  props: any
) => {
  return renderTypography(!!displayFunc ? displayFunc(value) : value, props);
};

const renderDate = (value: string, props: any) => {
    let date = ""
    if ( value !== null && value !== undefined && value !== "") {
        date = formatDate(value);
    }
    return renderTypography(date, props);
    }

const renderTypography = (value: string, props: any) => {
  return <Typography {...props}>{value}</Typography>;
};

export { renderNumber, renderString, renderDate, renderTypography, getPercentColor, toPercent };
